exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.disable-events[data-v-6f651fd4] {\n    pointer-events: none\n}\n", ""]);
